/* eslint-disable react/jsx-props-no-spreading */

import React, { useEffect } from "react";

import Input from "components/lib/Shared/Input";
import { useSelector } from "react-redux";

// Electronic Address form with with common input for all ID types
const ElectronicAddress = ({ field, disabled, values, setFieldValue, formStepErrors }) => {

  const { modals } = useSelector((state) => state.modalsSlice);

  const handleSetEmail = (e) => {
    setFieldValue('email', e.target.value,);
  };

  const handleSetMobileNumber = (e) => {
    setFieldValue('mobileNumber', e.target.value,);
  };
  return (
    <div
      className={`${modals.length === 0
        ? "rounded-sm shadow-sm sm:rounded md:rounded-md px-4 sm:p-6"
        : ""
        } mt-4 bg-white`}
    >
      <h3 className="mb-2 text-lg font-medium leading-6 text-gray-900">
        Electronic Address
      </h3>
      <div className="grid grid-cols-6 gap-6">
        <div className="col-span-6 sm:col-span-3">
          <Input
            label="Email Address"
            name="emailAddress"
            placeholder="johndoe@gmail.com"
            type="email"
            value={values?.email ?? ""}
            errorPath="electronicAddress.emailAddress"
            onBlur={field.onBlur}
            onChange={handleSetEmail}
            disabled={disabled}
          />
          {formStepErrors?.email && (
            <small className="text-red-500 mt-2 py-4 px-1 font-semibold">
              {formStepErrors?.email}
            </small>
          )}
        </div>
        <div className="col-span-6 sm:col-span-3">
          <Input
            label="Mobile Number"
            name="mobileNumber"
            placeholder=""
            value={values?.mobileNumber ?? ""}
            errorPath="electronicAddress.mobileNumber"
            disabled={disabled}
            onBlur={field.onBlur}
            onChange={handleSetMobileNumber}
          />
          {formStepErrors?.mobileNumber && (
            <small className="text-red-500 mt-2 py-4 px-1 font-semibold">
              {formStepErrors?.mobileNumber}
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default ElectronicAddress;
